import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { Viewport } from '@radix-ui/react-toast';

const ToastViewport = React__default.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (jsx(Viewport, Object.assign({ ref: ref, className: className }, props)));
});
ToastViewport.displayName = "ToastViewport";

export { ToastViewport };
